import React from "react";
import * as auth from "../../store/ducks/auth.duck";
import { FormattedMessage, injectIntl } from "react-intl";
import "react-tabs/style/react-tabs.css";
import { Form, Tab } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card, Table } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";

class Orderpayed extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    
    this.orderlist = this.orderlist.bind(this);
    this.state = {
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      userData: [],
      amount:0,
      paymentdetail:"",
      userId:"",
      pay_id:"",
      pay_email:"",
      pay_mobile:"",
      pay_amount:"",
      pay_method:"",
      ordercontinue: "",
      pageset:"",
      uphonenumber:"",
      uemail:""

    };
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }
  orderlist () {
    if(this.state.ordercontinue == 'create') {
    this.props.history.push({ pathname: "/transaction/order/book-water" });
    }
    else {
      this.props.history.push({ pathname: "/transaction/order/order-list" });
    }
  }
  componentDidMount() {
   //console.log( this.props.userId ) 
  // this.setState({ paymentdetail: this.props.location.paymentdetails })
  // this.setState({ userId: this.props.location.user_id})
   //this.setState({ pay_id: this.props.location.p_id })

   let get_item = JSON.parse(localStorage.getItem('pay_data'))
   let  pay_details =""
   let payids=""
   if(get_item.passdata == 'wallet') {
    // console.log(get_item.paymentdetails.body.payment_id)
    
    
    let payids = get_item.paymentdetails.body.payment_id
    let postpaymentdata = { pay_id : payids  }
    fetch(process.env.REACT_APP_NODE_ENV + '/api/transaction/details', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postpaymentdata)
    }).then((response) => response.json())
      .then(data => {
        //this.setState({ amount : data.wallet_amount })
       
       // console.log(data)

        this.setState({ amount : data.transactiondata.wallet_amount,
            pay_email: data.transactiondata.email,
            pay_id: data.ordid,
            pay_mobile:  data.transactiondata.mobile,
            pay_amount:  data.transactiondata.transaction_amount,
            pay_method : data.transactiondata.method
         })

     
          })
  
    //console.log(payids)
    
   
   }
   else {
   let pay_details = JSON.parse(get_item.paymentdetails.body)
   let payids =pay_details.id
   let postpaymentdata = { pay_id : payids  }
   fetch(process.env.REACT_APP_NODE_ENV + '/api/transaction/details', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
     },
     body: JSON.stringify(postpaymentdata)
   }).then((response) => response.json())
     .then(data => {
       //this.setState({ amount : data.wallet_amount })
      
      // console.log(data)

       this.setState({ amount : data.transactiondata.wallet_amount,
        pay_email: data.transactiondata.email,
        pay_id: data.ordid,
        pay_mobile:  data.transactiondata.mobile,
        pay_amount:  data.transactiondata.transaction_amount,
        pay_method : data.transactiondata.method

        })

    
         })
 
   }
   this.setState({ ordercontinue: get_item.ordcontinue })
   if(get_item.ordcontinue == 'create') { 
     this.setState({  pageset: '/transaction/order/book-water' })
   }
   else {
    this.setState({  pageset: '/transaction/order/book-water' })

   }

//   console.log()
   
   
console.log(payids)
    let postAddressData = { user_id : get_item.user_id }
    fetch(process.env.REACT_APP_NODE_ENV + '/api/wallet/amount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postAddressData)
    }).then((response) => response.json())
      .then(data => {
        this.setState({ amount : data.wallet_amount })
        setTimeout(() => {
         // this.props.history.push({ pathname: "/wallet/addmoney" });

        }, 3000 );
        //console.log(data.wallet_amount)
      })


     
      let userpostdata = { user_id : get_item.user_id }
      fetch(process.env.REACT_APP_NODE_ENV + '/api/user/getUserdetailsId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(userpostdata)
      }).then((response) => response.json())
        .then(data => {
          
          this.setState({ usid: data.id , uemail: data.userEmail, uphonenumber : data.userPhoneNumber  })
         


        })




  }

  // delete = (id) => {
  //   const postApartmentCustomerData = {
  //     id: id
  //   };
  //   console.log(postApartmentCustomerData);
  //   fetch('/api/apart-customer/delete', {
  //     method: 'DELETE',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(postApartmentCustomerData)
  //   }).then(response => { if (response.ok) { this.componentDidMount() } })
  //     .then(data => console.log(data))
  //     .catch((err) => console.log(err))
  // };

  render() {
    // let userdatas = this.state.userData.map((data, index) => {
    //   return (
    //     <tr key={index}><td>{index + 1}</td><td>{data.id}</td>
    //       <td>{data.apartmentName}</td>
    //       <td>{data.apartmentPhoneNo}</td>
    //       <td>{data.doorNo + ", " + data.streetName + ", " + data.area}</td>
    //       <td> {data.city}</td>
    //       <td> {data.landmark}</td>
    //       <td><Button variant="outline-success" onClick={() => this.nextPath("/aprt-customer/customer-details", data.id)} >
    //         Details </Button></td></tr>)
    // });

    let dataArr = [];
    this.state.userData.map((data) => {
      let mdData = [
        data.individualId,
        data.name, data.alternateNumber, data.doorNumber + "," + data.streetName + "," + data.area + "," + data.city, data.landmark, data.id
      ];
      dataArr.push(mdData)
      return null;
    });


    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "alternateNumber",
        label: "Alternate Phone Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "address",
        label: "Address",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "landmark",
        label: "Landmark",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Button variant="outline-success" onClick={() => this.nextPath("/indiv-customer/customer-details", value)} >
                Details </Button>
                {/* &nbsp;&nbsp;&nbsp;<Button variant="outline-danger" onClick={() => this.delete(value)} >
                  Delete </Button>  */}
              </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none"
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Thankyou</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}>   
          <Card className="text-center">
  <Card.Header>
      <div style={{ fontSize: "20px",border: '1px solid #4cb54c' , borderRadius: '50%', background : '#4cb54c', color: '#fff', width: '40px', margin:'0 auto'  }}><i class="kt-menu__link-icon flaticon2-check-mark"></i> </div>
      <h1 style={{ color: "green" }}>Payment Successful</h1>
  </Card.Header>
  <Card.Body>
      <Card.Title style= {{ fontSize: "15px" }}>Your order has been placed successfully </Card.Title>
    <Card.Text  style= {{ fontSize: "15px" }}>
    Thank you for your interest in Gowatr
    </Card.Text>
  
    <div style={{ marginTop: "10px" }}>  
      <Table striped bordered hover  style={{ width:"50%", margin:"0 auto", fontSize:"12px" , fontWeight:"500", Border:"2px solid #c7c1c1; "}}>
     
    <tbody>
    <tr style={{ background:"#D0D0C7"  }}>
        <td style={{ width:"50%"  }}>Email Id</td>
        <td>{ this.state.uemail }</td>
      </tr>
      <tr >
        <td>Mobile Number</td>
        <td>{ this.state.uphonenumber  }</td>
      </tr>
      <tr style={{ background:"#D0D0C7" }}>
        <td>Payment Method</td>
      <td>{ this.state.pay_method }</td>
      </tr>
      <tr>
        <td>Order Id</td>
        <td>{ this.state.pay_id }</td>
      </tr>
      <tr style={{ background:"#D0D0C7"  }}>
        <td>Grand Total</td>
        <td>{ this.state.pay_amount }</td>
      </tr>
      
      <tr>
        <td>Status</td>
        <td> Success </td>
      </tr>
      


    </tbody>

      </Table>
      <Button  variant="outline-success" onClick={this.orderlist}>Continue</Button>

  </div>
  </Card.Body>
  
</Card>
            

          </div>
        </>
      );
   
  }
}

export default injectIntl(
    connect(
      null,
      auth.actions
    )(Orderpayed)
  );
  